
<script>
    import { Line } from 'vue-chartjs'

    import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)


    export default {
        extends: Line,

        props: ['options'],
        mounted () {
            // this.chartData is created in the mixin.
            // If you want to pass options please create a local options object
            this.renderChart(this.chartData, this.options)
        }
    }


</script>

<style>
    .small {
        max-width: 600px;
        margin:  150px auto;
    }
</style>
